import { useEffect, useState } from 'react';
import { getQualifications } from '../services/api';

/**
 * Choix des contacts à sortir avant l'export XLSX des antennes.
 *
 * « Antenne principale » = qualification `antenne_principale` (libellée
 * « Antenne actuelle ») : c'est elle que l'export met en évidence.
 *
 * Props : busy, onExport({ qualifications, principales, sans_contact }), onClose
 */
const AUCUNE = 'aucune';

export default function ExportAntennesModal({ busy = false, onExport, onClose }) {
  const [types, setTypes] = useState([]);
  const [selection, setSelection] = useState([]);
  const [principales, setPrincipales] = useState(false);
  const [sansContact, setSansContact] = useState(true);

  useEffect(() => {
    getQualifications()
      .then((data) => {
        const liste = [...(data || []), { value: AUCUNE, label: 'Sans type de profil' }];
        setTypes(liste);
        setSelection(liste.map((t) => t.value));
      })
      .catch(() => setTypes([]));
  }, []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  const toggle = (value) =>
    setSelection((prev) => (prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]));

  const tous = types.length > 0 && selection.length === types.length;
  const rien = !principales && selection.length === 0;

  const lancer = () => {
    if (rien || busy) return;
    const params = { sans_contact: sansContact ? 'true' : 'false' };
    if (principales) params.principales = 'true';
    // Tout coché = pas de filtre : les qualifications inconnues de la liste sortent aussi.
    else if (!tous) params.qualifications = selection.join(',');
    onExport?.(params);
  };

  const label = { display: 'flex', alignItems: 'center', gap: 8, fontSize: 13.5, color: '#334155', cursor: 'pointer' };

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,.5)', zIndex: 1100,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 460, background: 'white', borderRadius: 14, padding: 22 }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <h3 style={{ margin: 0, fontSize: 17, color: '#0f172a' }}>Exporter les antennes</h3>
          <button
            onClick={onClose}
            aria-label="Fermer"
            style={{ border: 'none', background: 'transparent', fontSize: 22, cursor: 'pointer', color: '#94a3b8', lineHeight: 1 }}
          >
            &times;
          </button>
        </div>

        <p style={{ margin: '10px 0 14px', fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>
          Choisissez les contacts à inclure. Les antennes principales (« Antenne actuelle ») sont surlignées en vert dans le fichier.
        </p>

        <label style={{ ...label, fontWeight: 600, marginBottom: 12 }}>
          <input type="checkbox" checked={principales} onChange={(e) => setPrincipales(e.target.checked)} />
          Uniquement les antennes principales
        </label>

        <fieldset
          disabled={principales}
          style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: '10px 14px', margin: 0, opacity: principales ? 0.5 : 1 }}
        >
          <legend style={{ fontSize: 12, color: '#64748b', padding: '0 4px' }}>Types de profil</legend>
          <label style={{ ...label, marginBottom: 6, fontWeight: 500 }}>
            <input
              type="checkbox"
              checked={tous}
              onChange={() => setSelection(tous ? [] : types.map((t) => t.value))}
            />
            Tous
          </label>
          {types.map((t) => (
            <label key={t.value} style={{ ...label, marginLeft: 18, marginBottom: 4 }}>
              <input type="checkbox" checked={selection.includes(t.value)} onChange={() => toggle(t.value)} />
              {t.label}
            </label>
          ))}
        </fieldset>

        <label style={{ ...label, marginTop: 12 }}>
          <input type="checkbox" checked={sansContact} onChange={(e) => setSansContact(e.target.checked)} />
          Inclure les villes sans contact correspondant
        </label>

        {rien && (
          <p style={{ margin: '10px 0 0', fontSize: 12.5, color: '#b91c1c' }}>Sélectionnez au moins un type de profil.</p>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 20 }}>
          <button className="k-btn k-btn-secondary" onClick={onClose} disabled={busy}>Annuler</button>
          <button className="k-btn k-btn-primary" onClick={lancer} disabled={rien || busy}>
            {busy ? 'Export en cours…' : 'Exporter'}
          </button>
        </div>
      </div>
    </div>
  );
}
